import modalsObserver from './modules/modalsObserver-functions';

modalsObserver.init();



// WEBPACK FOOTER //
// ./cpanel/js/components/modals/modalsObserver.js